import PropTypes from 'prop-types'
import React from 'react'
import { getInputClasses } from '../../helpers/obtenerClasesInput'
import useError from '../hooks/useError'
import useWarning from '../hooks/useWarning'

const Input = React.forwardRef((props, ref) => {
  const { name, className, disabled, onFocus, onFocusSelected, errores, warnings, ...rest } = props
  const { ShowError, hayError } = useError(errores, name)
  const { ShowWarning, hayWarning } = useWarning(warnings, name)

  const handleFocus = (event) => onFocusSelected && event.target.select()

  return (
    <>
      <input
        {...rest}
        ref={ref}
        name={name}
        id={name}
        className={getInputClasses(className, { disabled, hayError, hayWarning })}
        disabled={disabled}
        onFocus={onFocus ? onFocus : handleFocus}
        aria-disabled={disabled}
      />
      {<ShowError />}
      {<ShowWarning />}
    </>
  )
})

Input.displayName = 'Input'
Input.defaultProps = {
  type: 'text'
}

Input.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'email', 'date', 'number', 'password']),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onFocus: PropTypes.func,
  onFocusSelected: PropTypes.bool,
  errores: PropTypes.object,
  warnings: PropTypes.object
}

export default Input
